import {
  AdminAppAction,
  PlaceActionType,
  UpdatePlaceErrorAction,
  UpdatePlaceRequestAction,
  UpdatePlaceSuccessAction,
  updatePlaceError,
  updatePlaceSuccess,
} from '../../actions';
import { Epic, ofType } from 'redux-observable';
import { LIST_PLACES_QUERY, ListPlacesData } from '../../queries';
import {
  UPDATE_PLACE_MUTATION,
  UpdatePlacePayload,
  UpdatePlaceVariables,
} from '../../mutations';
import { getPlaceId, getUpdatePlaceInput } from '../../selectors';
import { AdminAppState } from '../../state';
import { EpicDependencies } from '../epic-dependencies';
import { MutationUpdaterFn } from 'apollo-client';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

const update = (
  variables: UpdatePlaceVariables,
): MutationUpdaterFn<UpdatePlacePayload> => (cache, { data }) => {
  const query = cache.readQuery<ListPlacesData>({
    query: LIST_PLACES_QUERY,
  });
  if (data && query) {
    const edges = [...query.places.edges];
    for (const edge of edges) {
      if (edge.node.id === variables.id) {
        edge.node = {
          ...edge.node,
          ...variables.input,
        };
      }
    }
    cache.writeQuery<ListPlacesData>({
      query: LIST_PLACES_QUERY,
      data: {
        ...query,
        places: { ...query.places, edges },
      },
    });
  }
};

export const updatePlaceEpic: Epic<
  AdminAppAction,
  UpdatePlaceSuccessAction | UpdatePlaceErrorAction,
  AdminAppState,
  EpicDependencies
> = (
  action$,
  state,
  { client },
): Observable<UpdatePlaceSuccessAction | UpdatePlaceErrorAction> =>
  action$.pipe(
    ofType<AdminAppAction, UpdatePlaceRequestAction>(
      PlaceActionType.UpdatePlaceRequest,
    ),
    switchMap(async (action: UpdatePlaceRequestAction) => {
      const variables = {
        id: getPlaceId(action.placeKey)(state.value),
        input: getUpdatePlaceInput(action.placeKey)(state.value),
      };

      const { data, errors } = await client.mutate<
        UpdatePlacePayload,
        UpdatePlaceVariables
      >({
        errorPolicy: 'all',
        mutation: UPDATE_PLACE_MUTATION,
        update: update(variables),
        variables,
      });

      if (errors) {
        return updatePlaceError(action.placeKey, errors);
      } else if (data) {
        return updatePlaceSuccess(action.placeKey);
      } else {
        throw new Error('No data.');
      }
    }),
  );
